<template>
  <SiteNav v-if="$beet.isReady" />
  <router-view v-slot="{ Component }">
    <transition name="fade-fast" mode="out-in" appear>
      <div :key="$route.name" class="app">
        <component :is="Component" v-if="$beet.isReady" />
        <Loader v-else />
      </div>
    </transition>
  </router-view>

  <SiteFooter v-if="$beet.isReady" />

  <Gdpr :options="{ backgroundColor: '#E5F3FE', color: '#0D294B' }" />
</template>

<script>
import Loader from '@/components/blocks/Loader.vue'
import SiteNav from '@/components/blocks/SiteNav.vue'
import Gdpr from '@/components/gdpr/Gdpr.vue'
import SiteFooter from '@/components/sections/SiteFooter.vue'
import { useLangRouter } from '@/extensions/langRouter'

export default {
  name: 'App',
  setup() {
    useLangRouter()
  },
  components: { Gdpr, Loader, SiteFooter, SiteNav },
  watch: {
    '$i18n.locale': {
      handler: async function (to) {
        await this.$beet.fetchCoreData(to)
      },
      immediate: true,
    },
    $route: {
      handler(to, from = {}) {
        const delay = to.name !== from.name ? 400 : 100
        setTimeout(() => {
          const el = to.hash ? document.querySelector(to.hash) : null
          if (el) {
            el.scrollIntoView({ behavior: 'smooth', block: 'start' })
          } else {
            window.scrollTo({ top: 0, behavior: 'smooth' })
          }
        }, delay)
      },
      immediate: true,
    },
  },
}
</script>
